// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BEM9","content":"styles_content__14jht"};